<template>
  <div class="checkout-footer bottom-footer grid container">
    <section class="footer-navigation" aria-labelledby="footer-support-links">
      <h2 id="footer-support-links" class="sr-only">{{ $t('text.help') }}</h2>
      <ul class="checkout-footer__navigation-holder">
        <slot name="navigation-nodes" />
      </ul>
    </section>
    <section
      class="flex flex-col lg:flex-row lg:justify-between items-start md:items-center flex-wrap md:bg-none py-4 mb-3 md:mb-5"
      aria-labelledby="footer-legal-links"
    >
      <span
        id="footer-legal-links"
        class="inline-block text-sm text-gray-90 leading-tight lg:leading-snug font-body no-underline hover:underline"
      >
        {{ notice }}
      </span>
      <nav class="ml-0 md:ml-auto" :aria-label="$t('aria.navigation.footer')">
        <slot name="footer-items" />
      </nav>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    notice: {
      type: String,
      required: true,
    },
    cdnStaticFilesRoot: {
      type: String,
      default: '',
    },
  },
};
</script>
